/**
 * Översätter tekniska felmeddelanden från inloggningstjänsten till svensk,
 * begriplig text. Används överallt där vi visar ett auth-fel för användaren.
 */

const RULES: Array<[RegExp, string]> = [
  [
    /password.*(weak|known|pwned|compromised|leak)/i,
    "Lösenordet är för vanligt och lätt att gissa. Välj ett annat.",
  ],
  [
    /password should be at least|password.*too short|shorter than/i,
    "Lösenordet är för kort. Använd minst 8 tecken.",
  ],
  [/invalid login credentials/i, "Fel e-post eller lösenord. Försök igen."],
  [
    /already registered|already exists|user_already_exists|duplicate/i,
    "Det finns redan ett konto med den e-postadressen. Logga in i stället.",
  ],
  [
    /email not confirmed/i,
    "E-postadressen är inte bekräftad än. Klicka på länken i mejlet vi skickade.",
  ],
  [
    /rate limit|too many requests|over_email_send_rate_limit|429/i,
    "Du har försökt för många gånger. Vänta en stund och prova igen.",
  ],
  [
    /(token|link).*(expired|invalid)|invalid.*(token|link)|otp_expired/i,
    "Länken har gått ut eller är redan använd. Begär en ny.",
  ],
  [/unable to validate email|invalid email|email.*invalid/i, "E-postadressen ser inte giltig ut."],
  [/user not found/i, "Vi hittar inget konto med den e-postadressen."],
  [
    /signups? not allowed|signup_disabled/i,
    "Det går inte att skapa konto just nu. Försök igen senare.",
  ],
  [
    /same.*password|should be different/i,
    "Det nya lösenordet måste skilja sig från det gamla.",
  ],
  [
    /unsupported provider|provider is not enabled/i,
    "Den här inloggningsmetoden är inte påslagen just nu.",
  ],
  [
    /failed to fetch|network|ETIMEDOUT|ENOTFOUND/i,
    "Vi når inte servern just nu. Kontrollera din uppkoppling och försök igen.",
  ],
];

/** Ger en svensk text för ett fel, med en generell fallback i stället för engelsk rådata. */
export function authErrorText(err: unknown, fallback = "Något gick fel. Försök igen."): string {
  const raw =
    err instanceof Error
      ? err.message
      : typeof err === "string"
        ? err
        : typeof err === "object" && err && "message" in err
          ? String((err as { message: unknown }).message)
          : "";
  if (!raw) return fallback;
  for (const [pattern, text] of RULES) if (pattern.test(raw)) return text;
  // Ren svenska redan? Visa den. Annars generell text.
  return /[åäöÅÄÖ]/.test(raw) || !/[a-z]/i.test(raw) ? raw : fallback;
}
